import * as firebase from 'firebase';
import firestore from 'firebase/firestore'

const settings = {timestampsInSnapshots: true};

const config = {
  apiKey: "IzaSyCQz8qNJENZpzNTs1n31xj2iZgt-apsgA0",
  authDomain: "fir-example-ec904.firebaseapp.com",
  databaseURL: "https://fir-example-ec904.firebaseio.com",
  projectId: "fir-example-ec904",
  storageBucket: "",
  messagingSenderId: "150404909804"
};
firebase.initializeApp(config);

firebase.firestore().settings(settings);

export default firebase;